import { resolveIncomeSelection } from "./common";
import { getDefaultCandidacyTenants } from "./defaultCandidacyChecks";
import { getProfileIncomeBreakdown } from "./profileCalculations";

export const getDefaultCandidacyIncome = (
  profiles,
  { user, _t, rent, selectionModel = null } = {}
) => {
  const selections =
    selectionModel &&
    new Map(
      selectionModel.flatMap((entry) =>
        entry.type === "tenant"
          ? [[entry.tenantId, entry.guarantorIds || []]]
          : (entry.participants || []).map((p) => [
              p.tenantId,
              p.guarantorIds || [],
            ])
      )
    );
  const selectedPeople = new Map();
  const addIncome = (person, role, income) => {
    if (!person || typeof person !== "object") return;
    const key = person._id ? String(person._id) : person;
    const existing = selectedPeople.get(key);
    if (existing && (existing.role === "tenant" || role === "guarantor"))
      return;
    const rawAmount = Number(income?.amount);
    const amount = Number.isFinite(rawAmount) && rawAmount > 0 ? rawAmount : 0;
    selectedPeople.set(key, {
      personId: person._id,
      role,
      income: { ...income, amount },
      amount,
    });
  };

  profiles.filter(Boolean).forEach((profile) => {
    getDefaultCandidacyTenants([profile]).forEach((tenant) => {
      if (selections && !selections.has(tenant._id)) return;
      const participant = profile.application_id?.participants?.find(
        (p) => p.tenant_info?._id === tenant._id
      );
      const incomeProfile = {
        ...profile,
        income_selection:
          resolveIncomeSelection(profile.income_selection, tenant._id) ||
          participant?.income_selection ||
          profile.income_selection,
      };
      const { tenantIncome, guarantorIncomes } = getProfileIncomeBreakdown(
        tenant,
        incomeProfile,
        {
          user,
          _t,
          deaWorkspace: false,
          guarantorIds: selections ? selections.get(tenant._id) : null,
        }
      );
      // Add the actual income amounts of all selected people. The profile's
      // tenant/guarantor effort type does not limit the global income.
      addIncome(tenant, "tenant", tenantIncome);
      guarantorIncomes.forEach(({ guarantor, income }) =>
        addIncome(guarantor, "guarantor", income)
      );
    });
  });

  const people = [...selectedPeople.values()];
  const totalIncome = people.reduce((sum, person) => sum + person.amount, 0);
  const monthlyRent = Number(rent);
  const effortRate =
    Number.isFinite(monthlyRent) && monthlyRent > 0
      ? (monthlyRent / totalIncome) * 100
      : null;
  return { people, totalIncome, effortRate };
};
